import {SuggestedConnection} from '@lib/store';

import {Skeleton} from '@molecules';

export const ConnectionSuggestionLoaderItem = () => {
  return (
    <div className="grid grid-cols-[auto_1fr_auto] gap-4 items-center w-full py-4 last:pb-0">
      <Skeleton className="w-12 h-12 rounded-full" />

      <div className="flex flex-col gap-2">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-4 w-24" />
      </div>

      <Skeleton className="w-6 h-6" />

      <div className="col-start-2 flex items-center gap-4">
        <Skeleton className="h-8 w-20" />
      </div>
    </div>
  );
};
